import { render, staticRenderFns } from "./NsEmailSimple.vue?vue&type=template&id=2e0411b6&scoped=true&"
import script from "./NsEmailSimple.vue?vue&type=script&lang=js&"
export * from "./NsEmailSimple.vue?vue&type=script&lang=js&"
import style0 from "./NsEmailSimple.vue?vue&type=style&index=0&id=2e0411b6&lang=scss&scoped=true&"
import style1 from "./NsEmailSimple.vue?vue&type=style&index=1&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2e0411b6",
  null
  
)

export default component.exports